export function setValueOfOptionalFields(setVal: any, previousVal: any, defaultVal: any ): any {
    if (setVal === undefined || setVal === null) {
        return previousVal || defaultVal;
    }

    return setVal;
}